



































































import { Component, Watch, Ref } from 'nuxt-property-decorator'
import { padStart } from 'lodash'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  UserSearchConditions,
  UserSearchConditionsItem,
  defaultUserSearchConditionsItem
} from '@/components/organisms/UserSearchCondition'
import {
  UserSearchTable,
  UserSearchTableItem,
  defaultUserSearchTableItem
} from '@/components/organisms/UserSearchTable'
import { AlertMessage, ErrorMessage, jobApi, userApi } from '@/api'
import {
  alertStore,
  modalUserSearchStore,
  modalErrorStore,
  systemParameterStore,
  modalJobListStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { CODE_KEY } from '@/config'
import { setErrorMessage } from '@/utils/error'
import { defaultSortColumn } from '@/components/molecules/DataTable'

@Component({
  components: {
    UserSearchTable,
    UserSearchConditions,
    ModalFooter
  }
})
export default class ModalUserSearch extends ModalComponentBaseVue {
  @Ref()
  userSearchConditions!: UserSearchConditions

  searchConditions: UserSearchConditionsItem = defaultUserSearchConditionsItem()

  searchedConditions: UserSearchConditionsItem = defaultUserSearchConditionsItem()

  tableBodyHeight: number = 0

  tableItem: UserSearchTableItem = defaultUserSearchTableItem()

  updatedUserIds: string[] = []

  get isOpen(): boolean {
    return modalUserSearchStore.isOpen
  }

  get oneHitTransition(): boolean {
    return (
      systemParameterStore.oneHitTransitionTargetSettingOnSearch.option1 === '1'
    )
  }

  get userIdMaxDigits(): number {
    return systemParameterStore.userIdMaxDigits
  }

  get isIdLengthMoreThanZeroLessThanIdMaxDigits(): boolean {
    return (
      this.searchConditions.id.input.length > 0 &&
      this.searchConditions.id.input.length < this.userIdMaxDigits
    )
  }

  @Watch('isOpen')
  initialize(): void {
    if (this.isOpen) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([
        CODE_KEY.USER_TYPE.KEY,
        CODE_KEY.GENDER.KEY,
        CODE_KEY.USER_STATUS.KEY,
        CODE_KEY.WORKING_TYPE.KEY,
        CODE_KEY.SCHOOL_GRADE_CODE.KEY,
        CODE_KEY.SCHOOL_CLASS_CODE.KEY
      ])
      systemParameterStore
        .fetchAllAndMergeByCodeKeys([
          CODE_KEY.NUMBER_MANAGEMENT.KEY,
          CODE_KEY.ONE_HIT_TRANSITION_TARGET_SETTING_ON_SEARCH.KEY,
          CODE_KEY.USER_SEARCH_PAGE_INITIAL_FOCUS.KEY
        ])
        .then(this.focus)
      this.$nextTick(this.calculateTableHeight)
    } else {
      this.searchConditions = defaultUserSearchConditionsItem()
      this.searchedConditions = defaultUserSearchConditionsItem()
      this.tableItem.items = []
      this.updatedUserIds = []
    }
  }

  mounted() {
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }

  onClickCancel(): void {
    modalUserSearchStore.cancel(this.updatedUserIds)
  }

  onClickOk(): void {
    modalUserSearchStore.ok(this.tableItem.selectedItem().id)
  }

  async onClickDownload() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const jobId = await jobApi.createUserList({
        ids: this.tableItem.items.map(item => item.id)
      })
      await modalJobListStore.newJobId(jobId)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async search() {
    if (document.activeElement !== null) {
      ;(document.activeElement as any).blur()
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    if (this.isIdLengthMoreThanZeroLessThanIdMaxDigits) {
      this.paddingIdByZero()
    }

    try {
      this.tableItem.items = (
        await userApi.searchUsers({
          name: this.searchConditions.name.input,
          id: this.searchConditions.id.input,
          birthday: this.searchConditions.birthday.input,
          phoneNumber: this.searchConditions.phoneNumber.input,
          address: this.searchConditions.address.input,
          mailAddress: this.searchConditions.mailAddress.input,
          gender: this.searchConditions.gender.input.code,
          userType: this.searchConditions.userType.input.code,
          status: this.searchConditions.status.input.code,
          areaCode: this.searchConditions.areaCode.input.code,
          workType: this.searchConditions.workType.input.code,
          studentGrade: this.searchConditions.studentGrade.input.code,
          studentClass: this.searchConditions.studentClass.input.code,
          studentNumber: this.searchConditions.studentNumber.input
        })
      ).map((result, index) => ({
        isSelected: index === 0,
        ...result
      }))
      this.tableItem.sortColumn = defaultSortColumn()
      this.searchedConditions = this.searchConditions

      if (this.tableItem.items.length === 1 && this.oneHitTransition) {
        this.openModalUserDetail(this.tableItem.items[0].id)
      }

      this.setScroll()
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          name: this.searchConditions.name,
          id: this.searchConditions.id,
          birthday: this.searchConditions.birthday,
          phoneNumber: this.searchConditions.phoneNumber,
          address: this.searchConditions.address,
          mailAddress: this.searchConditions.mailAddress,
          gender: this.searchConditions.gender,
          userType: this.searchConditions.userType,
          status: this.searchConditions.status,
          areaCode: this.searchConditions.areaCode,
          workType: this.searchConditions.workType,
          studentGrade: this.searchConditions.studentGrade,
          studentClass: this.searchConditions.studentClass,
          studentNumber: this.searchedConditions.studentNumber
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  paddingIdByZero(): void {
    this.searchConditions.id.input = padStart(
      this.searchConditions.id.input,
      this.userIdMaxDigits,
      '0'
    )
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  focus(): void {
    this.$nextTick(this.userSearchConditions.focus)
  }

  onClickNameLink(sortedIndex: number): void {
    this.tableItem.activeRowIndex = sortedIndex
    this.openModalUserDetail(this.tableItem.sortedItems()[sortedIndex].id)
  }

  clearSearchConditions(): void {
    this.searchConditions = defaultUserSearchConditionsItem()
    this.focus()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-user-search')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  openModalUserDetail(id: string) {
    this.$modalUserDetail.open({
      userId: id,
      searchResult: this.tableItem,
      isTitleLink: true,
      searchedConditions: { ...this.searchedConditions },
      displayOldIdAlert: true,
      onClickOk: this.onClickOk,
      onClickCancel: (isUpdated: boolean) => {
        if (isUpdated) {
          this.updatedUserIds.push(id)
        }
      }
    })
  }

  setScroll(): void {
    setTimeout(() => {
      const tableScroller: HTMLCollection | null = document.getElementsByClassName(
        'user-search-scroller'
      ) as HTMLCollectionOf<HTMLElement>

      tableScroller[0].scrollTo(0, this.tableItem.scrollTop)
    })
  }
}
